import { watch } from "vue";
import { useZipTextBox } from "./useZipTextBox";
import type { USAddressFormData } from "./_useUSAddressFormData";

/**
 * Manages the ZIP code field for a US address.
 * @param formData - The form data object containing the ZIP code.
 * @returns An object containing ZIP code display, validity, wrapper class, input handler, and reset function.
 */
export function useUSAddressZip(
  formData: USAddressFormData,
  zipInputId = "zip",
) {
  const zipField = useZipTextBox({ id: zipInputId });
  const {
    zipDisplay,
    zipRaw,
    isZipValid,
    wrapperClass: zipWrapperClass,
    handleZipInput: onZipInput,
  } = zipField;

  watch(zipRaw, (value) => {
    formData.zip = value;
  });

  const resetZip = () => {
    zipDisplay.value = "";
    formData.zip = "";
  };

  return {
    zipDisplay,
    isZipValid,
    zipWrapperClass,
    onZipInput,
    resetZip,
  };
}
